export const flower01Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2001.png";
export const flower02Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2002.png";
export const flower03Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2003.png";
export const flower04Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2004.png";
export const flower05Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2005.png";
export const flower06Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2006.png";
export const flower07Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2007.png";
export const flower08Url =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/flower%2008.png";
export const mainFrame =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/partners_main.png";
export const paper = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/paper.png";
export const envelope = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/envlope.png";
export const stamp = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/stamp.png";
export const bismillah = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/bismillah.svg";
export const partner01 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/partner01.png";
export const partner02 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/partner02.png";
export const partner03 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/partner03.png";
export const partners_ring =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/partners_ring.png";
export const stem = "https://storage.googleapis.com/public_viteslink_storage/images/invitation01/stem.png";
export const loveStoryPic01 =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/love-story-pic01.png";
export const loveStoryPic02 =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/love-story-pic02.png";
export const commentFrame =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation01/comment_input_frame.png";
